<template>
  <div class="wrapper information-page">
    <parallax
      class="section page-chat-header header-filter"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 md-xsmall-size-100 md-medium-size-66 mx-auto md-scrollbar"
          >
            <h1 class="title">Impressum</h1>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout md-size-100 mx-auto md-alignment-top-center">
            <div class="md-layout-item md-size-100">
              <div class="document-body">
                <article class="document-content" aria-label="Impressum">
                  <nav
                    class="document-navigation"
                    aria-label="Inhalt des Impressums"
                  >
                    <p class="document-navigation-title">Inhalt</p>
                    <a
                      href="#/impressum"
                      @click.prevent="scrollToSection('imprint-operator')"
                      >Betreiberin und Kontakt</a
                    >
                    <a
                      href="#/impressum"
                      @click.prevent="scrollToSection('imprint-liability')"
                      >Haftung und externe Links</a
                    >
                    <a
                      href="#/impressum"
                      @click.prevent="scrollToSection('imprint-copyright')"
                      >Urheberrecht</a
                    >
                  </nav>
                  <h2 id="imprint-operator" tabindex="-1">
                    Angaben gemäß § 5 DDG
                  </h2>
                  <p>Mehlhorn, Anna Katharina</p>
                  <p>Kastanienweg 45, 08301 Aue-Bad Schlema</p>

                  <h3>Kontakt</h3>
                  <p>
                    E-Mail:
                    <a href="mailto:anna.k.mehlhorn@gmx.de"
                      >anna.k.mehlhorn@gmx.de</a
                    >
                  </p>

                  <h2 id="imprint-liability" tabindex="-1">
                    Haftung und externe Links
                  </h2>
                  <h3>Haftung für Inhalte</h3>
                  <p>
                    Wir sind für die eigenen Inhalte dieser Website nach den
                    allgemeinen Gesetzen verantwortlich. Wenn uns konkrete
                    Rechtsverletzungen bekannt werden, prüfen wir die
                    betroffenen Inhalte und entfernen rechtswidrige Inhalte
                    unverzüglich.
                  </p>
                  <p>
                    Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt
                    der Kenntniserlangung einer konkreten Rechtsverletzung
                    möglich. Bei Bekanntwerden von den o.g. Rechtsverletzungen
                    werden wir diese Inhalte unverzüglich entfernen.
                  </p>
                  <h3>Externe Links</h3>
                  <p>
                    Unsere Webseite enthält Links auf externe Webseiten Dritter.
                    Auf die Inhalte dieser direkt oder indirekt verlinkten
                    Webseiten haben wir keinen Einfluss. Daher können wir für
                    die „externen Links“ auch keine Gewähr auf Richtigkeit der
                    Inhalte übernehmen. Für die Inhalte der externen Links sind
                    die jeweilige Anbieter oder Betreiber (Urheber) der Seiten
                    verantwortlich.
                  </p>
                  <p>
                    Die externen Links wurden zum Zeitpunkt der Linksetzung auf
                    eventuelle Rechtsverstöße überprüft und waren im Zeitpunkt
                    der Linksetzung frei von rechtswidrigen Inhalten. Eine
                    ständige inhaltliche Überprüfung der externen Links ist ohne
                    konkrete Anhaltspunkte einer Rechtsverletzung nicht möglich.
                    Bei direkten oder indirekten Verlinkungen auf die Webseiten
                    Dritter, die außerhalb unseres Verantwortungsbereichs
                    liegen, würde eine Haftungsverpflichtung ausschließlich in
                    dem Fall nur bestehen, wenn wir von den Inhalten Kenntnis
                    erlangen und es uns technisch möglich und zumutbar wäre, die
                    Nutzung im Falle rechtswidriger Inhalte zu verhindern.
                  </p>
                  <p>
                    Diese Haftungsausschlusserklärung gilt auch innerhalb des
                    eigenen Internetauftrittes
                    „<em>control-it-reflexion.de</em>“ gesetzten Links und
                    Verweise von Fragestellern, Blogeinträgern, Gästen des
                    Diskussionsforums. Für illegale, fehlerhafte oder
                    unvollständige Inhalte und insbesondere für Schäden, die aus
                    der Nutzung oder Nichtnutzung solcherart dargestellten
                    Informationen entstehen, haftet allein der Diensteanbieter
                    der Seite, auf welche verwiesen wurde, nicht derjenige, der
                    über Links auf die jeweilige Veröffentlichung lediglich
                    verweist.
                  </p>
                  <p>
                    Werden uns Rechtsverletzungen bekannt, werden die externen
                    Links durch uns unverzüglich entfernt.
                  </p>

                  <h2 id="imprint-copyright" tabindex="-1">Urheberrecht</h2>
                  <p>
                    Die auf unserer Webseite veröffentlichen Inhalte und Werke
                    unterliegen dem deutschen Urheberrecht (<a
                      href="http://www.gesetze-im-internet.de/bundesrecht/urhg/gesamt.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-extlink=""
                      >Urheberrechtsgesetz</a
                    >) . Die Vervielfältigung, Bearbeitung, Verbreitung und jede
                    Art der Verwertung des geistigen Eigentums in ideeller und
                    materieller Sicht des Urhebers außerhalb der Grenzen des
                    Urheberrechtes bedürfen der vorherigen schriftlichen
                    Zustimmung des jeweiligen Urhebers i.S.d. Urhebergesetzes
                    (<a
                      href="http://www.gesetze-im-internet.de/bundesrecht/urhg/gesamt.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-extlink=""
                      >Urheberrechtsgesetz</a
                    >&nbsp;). Downloads und Kopien dieser Seite sind nur für den
                    privaten und nicht kommerziellen Gebrauch erlaubt. Sind die
                    Inhalte auf unserer Webseite nicht von uns erstellt wurden,
                    sind die Urheberrechte Dritter zu beachten. Die Inhalte
                    Dritter werden als solche kenntlich gemacht. Sollten Sie
                    trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
                    bitten wir um einen entsprechenden Hinweis. Bei
                    Bekanntwerden von Rechtsverletzungen werden wir derartige
                    Inhalte unverzüglich entfernen.
                  </p>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollToSection from "@/utils/scrollToSection";

export default {
  name: "impressumView",
  bodyClass: "impressum",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/backgrounds/background5.png"),
    },
  },
  methods: { scrollToSection },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/information-pages.scss";
</style>
